import { Injectable } from '@angular/core';
import { DataService } from '../../../../../service/data.service';
import { HttpClient } from '@angular/common/http';
import { Observable, first, map, switchMap, catchError, of } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { CalendarClass } from '../class/calendar-class';

@Injectable({
  providedIn: 'root'
})
export class CalendarClassService {

  private _isFromMatrix = false;

  BASE_URL = environment.mkgoURL + '/api/v1/calendar-class';

  constructor(
    private _dataService: DataService,
    private _http: HttpClient
  ) { }

  getById(id: string): Observable<any> {
    return this._dataService.httpOptions(this._isFromMatrix).pipe(
      switchMap(options => this._http.get<CalendarClass>(`${this.BASE_URL}/${id}`, options)),
      first()
    );
  }

  getAll(): Observable<CalendarClass[]> {
    return this._dataService.httpOptions(this._isFromMatrix).pipe(
      switchMap(options => {
        return this._http.get<{ calendarClass: CalendarClass[] }>(this.BASE_URL, options).pipe(
          catchError(error => of({ calendarClass: [] }))
        );
      }),
      map(response => response.calendarClass || []),
      first(),
      catchError(error => of([]))
    );
  }

  create(cClass: CalendarClass): Observable<string> {
    return this._dataService.httpOptions(this._isFromMatrix).pipe(
      switchMap(options => this._http.post<any>(this.BASE_URL, cClass, options)),
      first(),
      map(resp => resp.id)
    );
  }

  update(cClass: CalendarClass): Observable<any> {
    return this._dataService.httpOptions(this._isFromMatrix).pipe(
      switchMap(options => this._http.put(`${this.BASE_URL}/${cClass._id}`, cClass, options)),
      first()
    );
  }

  delete(id: string): Observable<any> {
    const url = `${this.BASE_URL}/${id}`;
    return this._dataService.httpOptions(this._isFromMatrix).pipe(
      switchMap(options => this._http.delete<void>(url, options)),
      first()
    );
  }
}
